import { render, staticRenderFns } from "./BrbThumbnail.vue?vue&type=template&id=117f749f&"
import script from "./BrbThumbnail.vue?vue&type=script&lang=js&"
export * from "./BrbThumbnail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/matin/baarbaanet/frontend/panel/driver/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('117f749f')) {
      api.createRecord('117f749f', component.options)
    } else {
      api.reload('117f749f', component.options)
    }
    module.hot.accept("./BrbThumbnail.vue?vue&type=template&id=117f749f&", function () {
      api.rerender('117f749f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/brb-components/components/BrbThumbnail.vue"
export default component.exports